import React from "react";
import { PageHero } from "@/components/common/Bits";
import { useLanguage } from "@/context/LanguageContext";

/**
 * Generic placeholder page used for freshly-added menu items until real
 * content is filled from the admin panel or provided by the client.
 * Renders a hero with title + description and a friendly note.
 */
export default function PlaceholderPage({ title, description, overline, image }) {
  const { t } = useLanguage();
  return (
    <div data-testid="placeholder-page">
      <PageHero overline={overline} title={title} description={description} image={image}/>
      {!description && (
        <section className="py-20 useko-container max-w-3xl">
          <div className="prose-useko rich-content">
            <p>{t.content_coming_soon || "Bu bölümün detaylı içeriği kısa süre içinde eklenecektir. Ek bilgi ve iş birliği talepleri için lütfen İletişim sayfamızdan bize ulaşın."}</p>
          </div>
        </section>
      )}
    </div>
  );
}
